import React from 'react';
import {
    Row, Col,
} from 'reactstrap';

import 'react-toastify/dist/ReactToastify.css';

import Widget from '../../../components/Widget';
import s from '../Afiliaciones.module.scss';
import {Table, TableContainer, TableHead, TableRow, TableCell} from "@mui/material";
import {Detalles} from '../objects/detail'


import Images from "./images"
import UploadImages from "./ImageUpload";
class Detalle extends React.Component{
    state = {
        data : [],
        imageData:[],
        codigo: ""
    }
    API_URL = "/commerceDetail"
    API_IMAGES_URL = "/images"
     query = new URLSearchParams(this.props.location.search);
     codigoInt = this.query.get('codigo');

     URL = this.API_URL+"?codigo="+this.codigoInt;
     URL_IMAGES = this.API_IMAGES_URL+"?codigo="+this.codigoInt;
    componentDidMount() {
        fetch(this.URL)
            .then((response) => response.json())
            .then((data) => {
                var structure = [];
                let detalles;
                data.map(item => {
                    detalles = new Detalles(item.nit, item.fecha_radicado, item.mes, item.anio, item.nombre_comercio, item.banco, item.direccion, item.telefono1, item.telefono2, item.ejecutivo, item.lider, item.codigo, item.nueva, item.estado, item.pago, item.seccional, item.fecha_cu);

                });
                structure.push(detalles)
                this.setState({
                    data: detalles
                })
                this.setState({
                    codigo: this.state.data.codigo
                })
            });
        fetch(this.URL_IMAGES)
            .then((response) => response.json())
            .then((data) => {
                console.log(data)
                var images = [];
                data.map(item => {
                    images.push(item.foto1);
                    images.push(item.foto2);
                    images.push(item.foto3);
                    images.push(item.foto4);
                });

                this.setState({
                    imageData: images
                })
            });
        // console.log("------")
        // console.log(this.state.imageData)
        // console.log("------")
    }


    render() {

        return (
            <div className={s.root}>
                <Widget>
                    <Row>
                        <Col lg="12" xs="10">
                            <div>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>NIT</TableCell><TableCell>{this.state.data.nit}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>CÓDIGO ÚNICO</TableCell><TableCell>{this.state.data.codigo}</TableCell>

                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}} >FECHA RADICACIÓN</TableCell><TableCell>{this.state.data.fechaRadicacion}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}} >FECHA CU</TableCell><TableCell>{this.state.data.fecha_cu}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>AÑO</TableCell><TableCell>{this.state.data.anio}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>MES</TableCell><TableCell>{this.state.data.mes}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>NOMBRE COMERCIO</TableCell><TableCell>{this.state.data.nombre}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>BANCO</TableCell><TableCell>{this.state.data.banco}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>DIRECCIÓN</TableCell><TableCell>{this.state.data.direccion}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>TELÉFONO</TableCell><TableCell>{this.state.data.telefono}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>TELÉFONO 2</TableCell><TableCell>{this.state.data.telefono2}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>ASESOR</TableCell><TableCell>{this.state.data.asesor}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>TEAM LEADER</TableCell><TableCell>{this.state.data.leader}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>NUEVO O REFERIDO</TableCell><TableCell>{this.state.data.nuevo}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>ESTADO</TableCell><TableCell>{this.state.data.estado}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>PAGO</TableCell><TableCell>{this.state.data.pago}</TableCell>
                                                <TableCell style={{backgroundColor:"lightgrey"}}>SECCIONAL</TableCell><TableCell>{this.state.data.seccional}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Col>
                    </Row>
                </Widget>
                <Widget>
                    {/*<FileUploadButton codigo = {this.state.codigo}/>*/}
                    <UploadImages codigo = {this.state.codigo} />
                </Widget>
                <Widget>
                    <Images data = {this.state.imageData} />
                </Widget>
            </div>
        );
    }

}

export default Detalle;
